import { getHelsenorgeUrl, getTjenesterUrl } from '@helsenorge/framework-utils/hn-proxy-service';

/**
 * Legger til returparametere i URL-en hvis den peker til helsenorge.no eller tjenester.helsenorge.no, ellers returneres den originale URL-en.
 * Returparametere brukes til å overstyre hva som vises i brødsmulestien.
 *
 * @param url Absolutt URL til et av treffene i søkeresultatet
 * @param returnUrlText Tekst som skal vises i brødsmulestien når brukeren returnerer til søkeresultatet
 * @param returnUrl URL-en brukeren skal returnere til. Standard er gjeldende adresse (window.location.href)
 * @returns URL-en med returparametere lagt til hvis den peker til helsenorge.no eller tjenester.helsenorge.no, ellers returneres den originale URL-en
 */
export const getSearchHitUrl = (url: string, returnUrlText: string, returnUrl: string = window.location.href): string => {
  const helsenorgeUrl = getHelsenorgeUrl();
  const tjenesterUrl = getTjenesterUrl();
  const returParams = new URLSearchParams({
    retururl: returnUrl,
    retururltekst: returnUrlText,
  }).toString();

  const absoluteUrl = url.startsWith('/') ? `${helsenorgeUrl}${url}` : url;

  if (absoluteUrl.startsWith(helsenorgeUrl) || absoluteUrl.startsWith(tjenesterUrl)) {
    const separator = absoluteUrl.includes('?') ? '&' : '?';
    return `${absoluteUrl}${separator}${returParams}`;
  }

  return url;
};
